<template>
    <div class="settings-panel">
        <div class="settings-panel__inner">
            <mds-section
                e2e="reinvestment-section"
                :size="7"
                :collapsible="includeReinvestment"
                bold
                ref="section"
                border="secondary"
                @mds-section-expanded="expandSection"
                @mds-section-closed="closeSection"
            >
                <template v-slot:mds-section-title>
                    <span :class="{ 'reinvestments--disabled': !includeReinvestment }">
                        {{ getUILabel(text) }}
                    </span>
                </template>
                <template v-slot:mds-section-actions>
                    <mds-switch e2e="reinvestment-switch" v-model="includeReinvestment" @change="toggleInclude">{{ getUILabel("common_include") }}</mds-switch>
                </template>
                <template v-slot:default>
                    <div v-if="includeReinvestment">
                        <reinvestment-content :mwcId="getMwcIdForChild('content')"></reinvestment-content>
                    </div>
                </template>
            </mds-section>
            <reinvestment-summary v-if="!expanded && includeReinvestment" :mwcId="getMwcIdForChild('summary')"></reinvestment-summary>
        </div>
    </div>
</template>
<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import MwcVueHelperMixin from "mwc-vue-component-helper";
import MdsSwitch from "@mds/switch";
import MdsSection from "@mds/section";
import ReinvestmentContent from "./Content";
import ReinvestmentSummary from "./Summary";
import * as types from "../store/mutation-types";

export default {
    name: "reinvestment-panel",
    props: {
        text: String
    },
    mixins: [HypoVueBaseMixin, MwcVueHelperMixin],
    components: {
        MdsSwitch,
        MdsSection,
        ReinvestmentContent,
        ReinvestmentSummary
    },
    data() {
        return {
            expanded: false
        };
    },
    methods: {
        expandSection() {
            this.expanded = true;
        },
        closeSection() {
            this.expanded = false;
        },
        toggleInclude(value, event) {
            this.$refs.section.toggle(event);
        }
    },
    computed: {
        includeReinvestment: {
            get() {
                return this.$store.state.reinvestment.includeReinvestment;
            },
            set(value) {
                this.$store.commit(`reinvestment/${types.SET_INCLUDE_REINVESTMENT}`, value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.reinvestments--disabled {
    color: #9b9b9b;
}
</style>
